<div class="bet-counter-container" [class.has-bets]="betCounter > 0">
    <span class="bet-counter" [textContent]="betCounter || 0" data-crlat="betSlipCounter"> </span>
</div>
